import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ApplicationType } from 'enums/ApplicationType';
import { DocumentCategory } from 'enums/DocumentCategory';
import { DocumentStatus } from 'enums/DocumentStatus';

export interface Document {
  header: string;
  name: string;
  status: DocumentStatus;
  category: DocumentCategory;
}

export interface SetRequiredDocumentsPayload {
  requiredDocuments: Document[];
  applicationType?: string | null;
}

export interface DocumentsState {
  requiredDocuments: Document[];
}

const initialState: DocumentsState = {
  requiredDocuments: [],
};

const documents = createSlice({
  name: 'documents',
  initialState,
  reducers: {
    setRequiredDocuments: (state, { payload }: PayloadAction<SetRequiredDocumentsPayload>) => {
      state.requiredDocuments = payload.requiredDocuments
        .filter(
          (document) =>
            document.name &&
            document.category &&
            (!document.category.startsWith('Coborrower') ||
              (document.category.startsWith('Coborrower') && payload.applicationType === ApplicationType.Joint)),
        )
        .map((document) => {
          return {
            header: document.header,
            name: document.name,
            category: document.category as DocumentCategory,
            status: document.status as DocumentStatus,
          };
        });
    },
  },
});

export const { setRequiredDocuments } = documents.actions;

export default documents.reducer;
